import usePlanConfig from "~/hooks/usePlanConfig";
import useSale from "~/hooks/useSale";

const BecomeAMemberBanner = () => {
	const { planConfig } = usePlanConfig();

	const { promoCode, trialLength } = planConfig!;

	const { sale } = useSale();

	if ((!promoCode && !trialLength) || sale) return null;

	const discountLabel = promoCode?.coupon.amount_off
		? `$${promoCode?.coupon.amount_off / 100}`
		: `${promoCode?.coupon.percent_off}%`;

	if (!promoCode && !trialLength) return null;

	return (
		<>
			{trialLength && (
				<div className="rounded-lg border border-amber-100 bg-amber-50 px-3 py-1.5 font-medium text-amber-900 dark:border-amber-300/30 dark:bg-amber-300/20 dark:text-amber-100">
					Congratulations! You get a free trial for a {trialLength}.
				</div>
			)}

			{promoCode && (
				<div className="rounded-lg border border-emerald-100 bg-emerald-50 px-3 py-1.5 font-medium text-emerald-900 dark:border-emerald-700 dark:bg-emerald-300/20 dark:text-emerald-100">
					Congratulations! You get {discountLabel} off with the promotional
					code:{" "}
					<span className="font-bold text-emerald-600 dark:text-emerald-300">
						{promoCode.code}
					</span>
				</div>
			)}
		</>
	);
};

export default BecomeAMemberBanner;
